import { ImminenceTypes } from './types';

interface GetTypeImminenceProps {
  stateImminence: string;
  page: number;
  companyId: number;
}

interface CommentProps {
  bidding_comment: {
    bidding_id: string | number;
    message: string;
  };
}

export const GetImmminence = ({ stateImminence, page, companyId }: GetTypeImminenceProps) => ({
  types: [
    ImminenceTypes.GET_DADOS_IMMINENCE_REQUEST,
    ImminenceTypes.GET_DADOS_IMMINENCE_SUCCESS,
    ImminenceTypes.GET_DADOS_IMMINENCE_FAILURE,
  ],
  promise: (client: any) =>
    client.get(
      `/bidding_desert/imminence?${stateImminence}=true&page=${page}&companyId=${companyId}`,
    ),
});

export const SearchImmminence = (
  object: string,
  page: number,
  esfera: Array<number>,
  state: Array<number>,
  Getcities: Array<string>,
  startDate: any,
  endDate: any,
) => {
  return {
    types: [
      ImminenceTypes.SEARCH_IMMINENCE_REQUEST,
      ImminenceTypes.SEARCH_IMMINENCE_SUCCESS,
      ImminenceTypes.SEARCH_IMMINENCE_FAILURE,
    ],
    promise: (client: any) =>
      client.get(`/bidding_desert/imminence/search`, {
        params: {
          objeto: object,
          page,
          tipo_orgao_id: esfera,
          estados_ids: state,
          cidades_ids: Getcities,
          vigencia_inicio: startDate,
          vigencia_fim: endDate,
        },
      }),
  };
};
export const SearchItem = (
  item: string,
  states_ids: Array<number>,
  page: number,
  stateImminence: string,
) => ({
  types: [
    ImminenceTypes.GET_DADOS_IMMINENCE_REQUEST,
    ImminenceTypes.GET_DADOS_IMMINENCE_SUCCESS,
    ImminenceTypes.GET_DADOS_IMMINENCE_FAILURE,
  ],
  promise: (client: any) =>
    client.get(`/bidding_desert/imminence/search_item`, {
      params: { page, item, states_ids, stateImminence },
    }),
});

export const createCommentImminence = (
  biddingId: string | number,
  contactName: string,
  data: CommentProps,
  profileId: number,
) => {
  return {
    types: [
      ImminenceTypes.CREATE_COMMENT_REQUEST,
      ImminenceTypes.CREATE_COMMENT_SUCCESS,
      ImminenceTypes.CREATE_COMMENT_FAILURE,
    ],
    biddingId,
    contactName,
    profileId,
    promise: (client: any) => client.post('/minhas_licitacoes/comments', data),
  };
};

export const getComments = (biddingId: string) => {
  return {
    types: [
      ImminenceTypes.GET_COMMENTS_REQUEST,
      ImminenceTypes.GET_COMMENTS_SUCCESS,
      ImminenceTypes.GET_COMMENTS_FAILURE,
    ],
    biddingId,
    promise: (client: any) =>
      client.get(`/minhas_licitacoes/comments.json`, { params: { bidding_id: biddingId } }),
  };
};

export const destroyCommentImminence = (biddingId: string | number, commentId: string | number) => {
  return {
    types: [
      ImminenceTypes.DESTROY_COMMENT_REQUEST,
      ImminenceTypes.DESTROY_COMMENT_SUCCESS,
      ImminenceTypes.DESTROY_COMMENT_FAILURE,
    ],
    biddingId,
    commentId,
    promise: (client: any) => client.delete(`/minhas_licitacoes/comments/${commentId}`),
  };
};

export const createFavoriteImminance = (
  biddingId: string,
  contactName: string,
  companyId: number | null = null,
) => {
  const data = {
    bidding_id: biddingId,
    companyId,
  };
  return {
    types: [
      ImminenceTypes.CREATE_BIDDING_FAVORITE_REQUEST,
      ImminenceTypes.CREATE_BIDDING_FAVORITE_SUCCESS,
      ImminenceTypes.CREATE_BIDDING_FAVORITE_FAILURE,
    ],
    biddingId,
    contactName,
    companyId,
    promise: (client: any) => client.post('/minhas_licitacoes/favorites', data),
  };
};

export const destroyFavoriteImminance = (
  biddingId: string,
  contactName: string,
  companyId: number | null = null,
) => {
  const params = {
    data: {
      bidding_id: biddingId,
      companyId,
    },
  };

  return {
    types: [
      ImminenceTypes.DESTROY_BIDDING_FAVORITE_REQUEST,
      ImminenceTypes.DESTROY_BIDDING_FAVORITE_SUCCESS,
      ImminenceTypes.DESTROY_BIDDING_FAVORITE_FAILURE,
    ],
    biddingId,
    contactName,
    companyId,
    promise: (client: any) => client.delete(`/minhas_licitacoes/favorites/${biddingId}`, params),
  };
};

export const createImminenceManaged = (biddingId: number, companyId: number) => {
  const data = {
    bidding_id: biddingId,
    companyId,
  };
  return {
    types: [
      ImminenceTypes.CREATE_BIDDING_MANAGED_REQUEST,
      ImminenceTypes.CREATE_BIDDING_MANAGED_SUCCESS,
      ImminenceTypes.CREATE_BIDDING_MANAGED_FAILURE,
    ],
    biddingId,
    promise: (client: any) => client.post('/gerenciar_licitacoes/gerenciar', data),
  };
};

export const destroyImminenceManaged = (biddingId: number, companyId: number) => {
  const params = {
    data: {
      bidding_id: biddingId,
      companyId,
    },
  };
  return {
    types: [
      ImminenceTypes.DESTROY_BIDDING_MANAGED_REQUEST,
      ImminenceTypes.DESTROY_BIDDING_MANAGED_SUCCESS,
      ImminenceTypes.DESTROY_BIDDING_MANAGED_FAILURE,
    ],
    biddingId,
    promise: (client: any) => client.delete(`/gerenciar_licitacoes/gerenciar/${biddingId}`, params),
  };
};
